import { AbstractControl, ValidationErrors } from '@angular/forms';

// Custom email validator to match the exact requirement: at least one char + @ + [at least one char + . + at least one char](repeatable subdomains allowed)
export function customEmailValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;

    // Split into local and domain parts
    const parts = value.split('@');
    if (parts.length !== 2) return { customEmail: true };

    const [local, domain] = parts;

    // Local part validation: starts with letter, contains "a-zA-Z 0-9 . _ - +", no consecutive dots, does not end with dot
    if (!local || !/^[a-zA-Z]/.test(local) || /\.\./.test(local) || /\.$/.test(local) || !/^[a-zA-Z0-9._+-]+$/.test(local)) {
        return { customEmail: true };
    }

    // Domain validation: contains at least one dot, starts with letter, ends with letter/digit
    if (!domain || !domain.includes('.') || !/^[a-zA-Z]/.test(domain) || !/[a-zA-Z0-9]$/.test(domain) || !/^[a-zA-Z0-9.-]+$/.test(domain)) {
        return { customEmail: true };
    }

    return null;
}

// Custom validator to check for whitespace only inputs
export function noWhitespaceValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) return null;

    // Check if the value contains only whitespace
    if (typeof value === 'string' && value.trim().length === 0) {
        return { whitespaceOnly: true };
    }

    return null;
}
